import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

function App() {
  return (
    <div className="App">
      <Router>
        <ProtectedRoute />
      </Router>
    </div>
  );
}

export default App;
